<template>
  <div class="form-curriculum">
    <el-form
      size="mini"
      ref="form"
      :model="course_form"
      label-position="left"
      @submit.native.prevent
    >
      <el-form-item label="授课类型">
        <el-radio-group
          @change="handleChange"
          v-model="course_form.teaching_type"
        >
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="1">面授</el-radio-button>
          <el-radio-button label="2">直播</el-radio-button>
          <el-radio-button label="3">录播</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="所属科目">
        <el-radio-group v-model="course_form.subject_id" @change="handleChange">
          <el-radio label="">全部</el-radio>
          <el-radio
            v-for="item of subjectList"
            :key="item.id"
            :label="item.id"
            >{{ item.name }}</el-radio
          >
        </el-radio-group>
      </el-form-item>

      <el-form-item label="课程类型">
        <el-radio-group
          v-model="course_form.course_type"
          @change="handleChange"
        >
          <el-radio label="">全部</el-radio>
          <el-radio :label="1">体验课</el-radio>
          <el-radio :label="2">常规课</el-radio>
          <el-radio :label="3">短期课</el-radio>
        </el-radio-group>
        <div style="display: inline-block;margin-left: 30px;">
          <el-input
            v-model="course_form.lessonTitle"
            @keyup.enter.native="methodSearch"
            placeholder="搜索讲次名称"
            size="mini"
            clearable
          ></el-input>
        </div>
      </el-form-item>
    </el-form>

    <div class="section">
      <div class="subject">
        <el-row :gutter="20">
          <el-col :span="6" v-for="item of curriculumList" :key="item.id">
            <div class="courses">
              <div
                class="courses_img"
                @click="handleClickCard(item)"
                :style="{
                  backgroundImage: 'url(' + item.img_url + ')',
                }"
              ></div>
              <div class="courses_title" @click="handleClickCard(item)">
                <span style="float:left;">{{ item.title }} </span>
                <span
                  style="
                    float:left;
                    margin-left: 10px;
                    color: #f15a24;
                    font-size: 10px;
                    border: 1px solid #f15a24;
                    padding-left:4px;
                    padding-right:4px;
                    padding-top:2px;
                    padding-bottom:2px;
                    border-radius: 5px;
                  "
                  >{{ item.number_of_courses }}节</span
                >
              </div>

              <div class="courses_desc">
                {{ item.curriculum_desc }}
              </div>

              <div class="courses_date">
                <span style="float: left">难度</span>
                <el-rate
                  style="float: left; margin-left: 5px"
                  v-model="item.difficulty"
                  disabled
                  :colors="colors"
                >
                </el-rate>

                <span
                  v-if="item.for_grade"
                  style="
                    float: right;
                    color: #fcdc25;
                    font-size: 10px;
                    padding-left: 2px;
                    padding-right: 2px;
                    border-radius: 5px;
                    background: #e3eeff;
                    color: #609cfd;
                  "
                  >{{ item.for_grade }}</span
                >
              </div>
            </div>
          </el-col>
        </el-row>

        <div style="margin: 20px; text-align: right">
          <el-pagination
            @current-change="handleCurrent"
            :current-page="page_no"
            :page-size="page_size"
            layout="total, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      :title="curriculum_title"
      :visible.sync="dialogVisible"
      width="80%"
    >
      <el-table
        :data="curriculumMaterialList"
        :header-cell-style="{ background: 'white' }"
        size="mini"
        height="500px"
      >
        <el-table-column width="100" align="left" label="序号">
          <template slot-scope="scope"> 第{{ scope.$index + 1 }}讲 </template>
        </el-table-column>

        <el-table-column align="left" width="200" label="封面">
          <template slot-scope="scope">
            <el-image
              style="width: 96px; height: 72px; border-radius: 5px"
              :src="scope.row.img_url"
              fit="cover"
            >
            </el-image>
          </template>
        </el-table-column>

        <el-table-column
          align="left"
          prop="title"
          label="讲次名称"
        ></el-table-column>

        <el-table-column
          align="left"
          prop="desc"
          label="简介"
        ></el-table-column>

        <el-table-column width="200" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="prepare(scope.row.id)"
              >备课</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
//import { getPrepareCurrculumMaterialList } from "@/api/educational.js";

import {
  tchGetTchSubjectAuth,
  tchGetTchCurriculum,
} from '@/api/classroom/teacher_api'

export default {
  name: 'form-curriculum',
  props: {
    is_my_class: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      subjectList: [],
      curriculumList: [],

      //讲次列表弹窗
      curriculum_title: '',
      curriculumMaterialList: [],

      course_form: {
        subject_id: '',
        teaching_type: '',
        course_type: '',
        curriculumTitle: '',
        lessonTitle: '',
      },

      page_size: 20,
      page_no: 1,
      total: 0,

      dialogVisible: false,
      colors: ['#f6dd25', '#f6dd25', '#f6dd25'],
    }
  },

  mounted() {
    console.log('进入备课页面')

    if (this.$route.query.subject_id) {
      this.course_form.subject_id = this.$route.query.subject_id
    }

    if (this.$route.query.teaching_type) {
      this.course_form.teaching_type = this.$route.query.teaching_type
    }

    if (this.$route.query.course_type) {
      this.course_form.course_type = this.$route.query.course_type
    }

    this.tchGetTchSubjectAuth() //获得老师负责的科目
    this.tchGetTchCurriculum() //获得课程体系
  },
  methods: {
    handleCurrent(val) {
      this.page_no = val
      this.tchGetTchCurriculum()
    },

    //获取学校科目权限列表
    tchGetTchSubjectAuth() {
      console.log('查询老师科目权限')
      tchGetTchSubjectAuth().then((res) => {
        this.subjectList = res.subjectList
      })
    },
    //获得老师课程体系
    tchGetTchCurriculum() {
      tchGetTchCurriculum({
        subject_id: this.course_form.subject_id,
        teaching_type: this.course_form.teaching_type,
        course_type: this.course_form.course_type,
        curriculumTitle: this.course_form.curriculumTitle,
        lessonTitle: this.course_form.lessonTitle,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('获得老师课程体系')
        console.log(res)
        this.curriculumList = res.curriculumList
        console.log(this.curriculumList, 456789)
        this.total = res.total
      })
    },

    methodSearch() {
      this.tchGetTchCurriculum()
    },

    handleChange() {
      this.page_no = 1
      this.tchGetTchCurriculum()
    },

    handleClickCard(item) {
      console.log(item)

      this.$router.push({
        name: 'curriculum-detail',
        query: {
          id: item.id,
          subject_id: this.course_form.subject_id,
          course_type: this.course_form.course_type,
          teaching_type: this.course_form.teaching_type,
        },
      })
    },

    prepare(id) {
      this.dialogVisible = false

      this.$router.push({
        name: 'prepare',
        query: {
          curriculumMaterial_id: id,
          backname: 'prepare-lessons',
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.form-curriculum {
  .subject {
    .el-row {
      display: flex;
      flex-wrap: wrap;
    }
    .courses {
      border: 1px solid #e4e7ed;

      display: flex;
      flex-flow: column;
      margin-bottom: 20px;
      border-radius: 5px;
      background: white;
      cursor: pointer;

      .courses_img {
        height: 0;
        padding-bottom: 69%;
        background-repeat: no-repeat;
        // background-size: cover;
        background-size: 100% 100%;

        border-radius: 5px 5px 0px 0px;

        .coursesimg {
          width: 100%;
          border-radius: 5px 5px 0px 0px;
        }
      }

      .courses_title {
        flex: 1;
        font-size: 16px;
        margin-left: 10px;
        margin-top: 10px;
        font-weight: bold;
      }

      .courses_desc {
        margin-left: 10px;
        margin-right: 10px;
        margin-top: 5px;
        margin-bottom: 5px;
        min-height: 36px;

        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      .courses_date {
        margin-left: 10px;
        margin-right: 10px;
        margin-bottom: 10px;
        margin-top: 5px;
      }
    }
  }

  .dialogBtn {
    float: right;
    margin-bottom: 20px;
  }
}
</style>
